import { render } from "./OrderWildcard.vue?vue&type=template&id=39b83b96&scoped=true&ts=true"
import script from "./OrderWildcard.vue?vue&type=script&lang=ts"
export * from "./OrderWildcard.vue?vue&type=script&lang=ts"

import "./OrderWildcard.vue?vue&type=style&index=0&id=39b83b96&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b83b96"]])

export default __exports__